module.exports = __webpack_public_path__ + "img/D201609_5.c4561dc8.jpg";